<template>
  <div class="card-number">
    <ul class="xmly-table-part">
      <li class="item" v-if="!!(numberData.data && numberData.data[item.key]!=undefined) && item.role.indexOf(promotorType) !== -1"
          v-for="item in txtArray" :key="item.key">
        <router-link
          :to="item.key=='inServiceDistributerCount' ? {name:'distributorManager'}: item.key=='subSiteCount' ? {name:'SubManager'} : ''">
          <p class="count">{{numberData.data[item.key]}}</p>
          <p class="tit" > {{item.txt}} </p>
          <p class="toDataCenter" v-if="!numberData.model && item.key=='lockUserCount'" @click="toLockDetail">查看详情</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      //SubManager    distributorManager
      const model = this.numberData && this.numberData.model;
      let txtArray = [];
      if (model ) {
        txtArray = [{
            txt: '分成比例',
            key: 'shareRatio',
            role: [1,2]
          }, {
            txt: '在职分销商',
            key: 'inServiceDistributerCount',
            role: [1,2]
          }, {
            txt: '子站数',
            key: 'subSiteCount',
            role: [1,2]
          }
        ]
      } else {
        txtArray = [
          {
            txt: '销售金额',
            key: 'salesAmount',
            role: [1,2]
          },
          {
            txt: '佣金',
            key: 'commission',
            role: [1,2]
          },
          {
            txt: '付费订单数',
            key: 'paidOrderCount',
            role: [1,2]
          },
          // {
          //   txt: '付费用户数',
          //   key: 'paidUserCount',
          //   role: [1,2]
          // },
          {
            txt: '锁定用户数',
            key: 'lockUserCount',
            role: [1,2]
          }
        ]
      }
      return {
        txtArray: txtArray
      }
    },
    computed: {
      ...mapGetters([
        'promotorType',
        'isPromotorDisplay'
      ])
    },
    watch: {
      numberData: function (val) { //根据分销商合伙人以及appRatio是否为null展示站内站外分成比例
        if(val.model == 'real_time' && val.data.appRatio != null) {
          this.txtArray = [{
              txt: '站外分成比例',
              key: 'shareRatio',
              role: [1,2]
            }, {
              txt: '站内分成比例',
              key: 'appRatio',
              role: [1,2]
            }, {
              txt: '在职分销商',
              key: 'inServiceDistributerCount',
              role: [1,2]
            }, {
              txt: '子站数',
              key: 'subSiteCount',
              role: [1,2]
            } ]
        }
      }
    },
    created() {
      if (!this.isPromotorDisplay) {
        for (let item of this.txtArray) {
          if (item.key=='lockUserCount') {
            item.role=[1]
          }
        }
      }
    },
    props: ['numberData'],
    methods: {
      toLockDetail(e) {
        e.preventDefault();
        this.$router.push({name: 'lockUserDetail'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-number {
    margin-bottom: 10px;
  }

  .xmly-table-part {
    padding-left: 0px;
    display: table;
    width: 100%;
    margin: 42px 0 20px 0;
  }

  .xmly-table-part .item {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }

  .xmly-table-part .count {
    font-size: 24px;
    color: #f59d00;
  }

  .xmly-table-part .tit {
    font-size: 14px;
    color: #333;
    margin-top: 3px;
  }

  .xmly-table-part .item:after {
    position: absolute;
    content: '';
    width: 1px;
    top: 0;
    bottom: 0;
    background: #dfe6ec;
    right: 0;
  }

  .xmly-table-part .item:last-child:after {
    content: none;
  }

  .xmly-table-part .toDataCenter {
    position: absolute;
    left: 0;
    bottom: -17px;
    width: 100%;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// number.vue?f76ea19c